import React from 'react';
import { ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-screen w-full bg-stone-deep flex items-center justify-center overflow-hidden pt-20" data-id="element-56">
      {/* Background image */}
      <img src="https://cdn.magicpatterns.com/uploads/qBGzwnijDaiPnpf6EG7iW4/chuck3.webp" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-40" data-id="element-57" />
      <div className="absolute inset-0 bg-stone-deep/70" data-id="element-58"></div>

      {/* Abstract Background Elements to simulate desert night/boulders */}
      <div className="absolute inset-0 opacity-20" data-id="element-59">
        <svg className="absolute bottom-0 left-0 w-full h-1/2" viewBox="0 0 1440 320" preserveAspectRatio="none" data-id="element-60">
          <path fill="#C8A96E" fillOpacity="0.3" d="M0,256L48,229.3C96,203,192,149,288,154.7C384,160,480,224,576,218.7C672,213,768,139,864,128C960,117,1056,171,1152,197.3C1248,224,1344,224,1392,224L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" data-id="element-61"></path>
        </svg>
        <svg className="absolute bottom-0 right-0 w-3/4 h-2/3" viewBox="0 0 1440 320" preserveAspectRatio="none" data-id="element-62">
          <path fill="#7C5230" fillOpacity="0.2" d="M0,128L60,144C120,160,240,192,360,181.3C480,171,600,117,720,112C840,107,960,149,1080,165.3C1200,181,1320,171,1380,165.3L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z" data-id="element-63"></path>
        </svg>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto flex flex-col items-center" data-id="element-64">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif text-cream mb-6 leading-tight" data-id="element-65">
          Where the Desert <br className="hidden md:block" data-id="element-66" /> Meets Luxury
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-sand tracking-widest uppercase mb-12" data-id="element-67">
          38809 N Boulder View Dr Scottsdale, Arizona
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center gap-6" data-id="element-68">
          <a href="#about" className="w-full sm:w-auto px-8 py-4 rounded-full border border-sand text-sand uppercase tracking-widest text-sm hover:bg-sand hover:text-stone-deep transition-all duration-300" data-id="element-69">
            View the Home
          </a>
          <a href="#schedule" className="w-full sm:w-auto px-8 py-4 rounded-full bg-sand text-stone-deep uppercase tracking-widest text-sm hover:bg-cream transition-all duration-300" data-id="element-70">
            Schedule a Tour
          </a>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.2
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center text-sand/60 animate-bounce" data-id="element-71">
        <span className="text-xs uppercase tracking-widest mb-2" data-id="element-72">Scroll</span>
        <ChevronDown size={20} data-id="element-73" />
      </motion.div>
    </section>;
}